import { Form, Formik } from "formik";
import pokemon from "pokemontcgsdk";
import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import ProductImage from "../../../../assets/images/productimage.png";
import {
  buttonNameConstants,
  buttonTypeConstants,
  defaultGridState,
  EMPTY_STRING,
  globalConstants,
  INITIAL_VALUE_TYPES,
  inventoryConstants,
  PRODUCT_JSON_TYPE,
  routesPathConstants,
  shopifyConstants,
  toastMessages,
  toastType,
} from "../../../../constants";
import {
  inventoryActions,
  shopifyActions,
  systemActions,
} from "../../../../redux/actions";
import { Button, Topbar } from "../../../../shared/components";
import {
  calculateProfitAndMargin,
  convertToFixedPrecision,
  createCompanyDynamicUrl,
  customToast,
  getAddInventoryPartialInitialValues,
  getAddInventoryPricePayloadObject,
  getAddInventoryRootPayloadPartialObject,
  getDefaultFields,
  getDefaultShopifySettings,
  getMappedShopifyFields,
  getProductImage,
  getProductSubCategory,
  getProfit,
  getProfitMargin,
  getShortestSku,
  getTypeOrCategoryIdByName,
  getTypeOrCategoryObject,
  getUnitPurchasePriceOfDbProduct,
  handleAddInventorySubmitBeautify,
  handleAverageOutUnitPurcasePrice,
  handleBeautifyMarketPrice,
  handleConditionChange,
  handleIsCustomItem,
  handleIsLinkToShopify,
  setDefaultProductDataObject,
  isProductMetaDataSame,
  isSerialNumberUnique,
  isShopifyConnected,
  isSpinnerEnabled,
  isSystemProduct,
  isTransferInventoryEnabled,
  parseToDecimalNumber,
  prepareFilterForInventoryHistoryPaginationCall,
} from "../../../../shared/utility";
import { editInventoryValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import { PRODUCT_TYPES_ENUMS } from "../../../../system/globalEnums";
import ShopifyPresetsMappingModal from "../../../Settings/ShopifyPresets/AddNewPreset/ShopifyPresetsMappingModal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import PrintLabelModal from "../printingLabelModal/PrintLabelModal";
import TransferInventoryModal from "../TransferInventoryModal/TransferInventoryModal";
import EditInventoryLeftColumn from "./EditInventoryLeftColumn";
import EditInventoryRightColumn from "./EditInventoryRightColumn";
import ItemHistoryModal from "./ItemHistoryModal/ItemHistoryModal";
import ProductImageCard from "../../../../shared/components/productDetailCard/ProductImageCard";

pokemon.configure({ apiKey: process.env.REACT_APP_POKEMON_API_KEY });

const EditInventory = (props) => {
  //------- destucture props
  const {
    stores,
    currentStoreCompany,
    inventory,
    productTags,
    customTypes,
    currentStore,
    spinnerArray,
    updateInventory,
    quantityShrink,
    activateSpinner,
    customCategories,
    inventoryProducts,
    deactivateSpinner,
    customSubCategories,
    getShopifyMappingsById,
    getTcgPlayerProductById,
    priceChartingProductInfo,
    setProductShopifySettings,
    createProductMappingObject,
    setPokemonProductInReducer,
    getPricechartingProductById,
    setPriceChartingProductInfo,
    emptyShopifyProductSettings,
    getPaginatedInventoryHistory,
    getInventoryByPricechartingId,
    getInventoryByCustomItemCheck,
    emptyPriceChartingProductObject,
    shopify,
  } = props;

  //-------preset prices
  const { inventoryHistory, productShopifySettings } = inventory;

  const { state } = useLocation();
  const navigate = useNavigate();

  //-------is shopify store connected?
  const isShopifyStoreConnected = isShopifyConnected(currentStore);

  //------- usestates
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [showIframe, setShowIframe] = useState(false);
  const handleCloseIfram = () => setShowIframe(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [conditionList, setConditionList] = useState([]);
  const [productTagsList, setProductTagsList] = useState([]);
  const [productUrl, setProductUrl] = useState(EMPTY_STRING);
  const [initialMapping, setInitialMapping] = useState(false);
  const [productCondition, setProductCondition] = useState({});
  const [shrinkValue, setShrinkValue] = useState(EMPTY_STRING);
  const [printLabelModal, setPrintLabelModal] = useState(false);
  const [isItemHistoryModal, setIsItemHistoryModal] = useState(false);
  const [updatedInventory, setUpdatedInventory] = useState(EMPTY_STRING);
  const [isShopifyPresetModal, setIsShopifyPresetModal] = useState(false);
  const [isConsolidationModal, setIsConsolidationModal] = useState(false);
  const [productDataObject, setProductDataObject] = useState({
    imgUrl: state?.data?.imgUrl,
    shopifySettingId: state?.data?.shopifySettingId,
  });

  const [isTransferInventoryModal, setIsTransferInventoryModal] =
    useState(false);
  const [productType, setProductType] = useState(PRODUCT_TYPES_ENUMS.ALL);
  const [gridState, setGridState] = useState({
    ...defaultGridState,
    pageSize: inventoryConstants.ITEM_HISTORY_LIST_LENGTH,
  });
  const [timeFrame, setTimeFrame] = useState({
    start: "",
    end: "",
    duration: "all",
  });
  const [transactionType, setTransactionType] = useState({
    label: globalConstants.ALL,
    value: globalConstants.ALL,
  });

  //------useRef
  const formRef = useRef(null);
  const hiddenFileInput = useRef(null);
  const isFirstRenderRef = useRef(true);

  //------- initial Constants
  const isCustomItem = handleIsCustomItem(state?.data);

  //------- form initial values
  const initialValues = {
    productName: state?.data?.product_name,
    condition: state?.data?.price?.type,
    productType: getTypeOrCategoryIdByName(
      customTypes,
      state?.data?.productType
    ),
    category_name: getTypeOrCategoryIdByName(
      customCategories,
      state?.data?.category_name,
      state?.data?.productType
    ),
    subcategory: getTypeOrCategoryIdByName(
      customSubCategories,
      state?.data?.subcategory,
      state?.data?.productType,
      state?.data?.category_name
    ),
    unitsellprice:
      state?.data?.price?.unit_sell_price !== null &&
      state?.data?.price?.unit_sell_price !== undefined
        ? parseToDecimalNumber(state.data.price.unit_sell_price)
        : EMPTY_STRING,
    costPerItem:
      state?.data?.price?.unit_purchase_price !== null &&
      state?.data?.price?.unit_purchase_price !== undefined
        ? convertToFixedPrecision(state.data.price.unit_purchase_price)
        : EMPTY_STRING,
    onlineCostPerItem:
      state?.data?.price?.onlineUnitPurchasePrice !== null &&
      state?.data?.price?.onlineUnitPurchasePrice !== undefined
        ? convertToFixedPrecision(state.data.price.onlineUnitPurchasePrice)
        : EMPTY_STRING,
    profit: getProfit(
      state?.data?.price?.unit_sell_price,
      state?.data?.price?.unit_purchase_price
    ),
    onlineProfit: getProfit(
      state?.data?.price?.onlinePrice,
      getUnitPurchasePriceOfDbProduct(state?.data)
    ),
    onlineMargin: getProfitMargin(
      state?.data?.price?.onlinePrice,
      getUnitPurchasePriceOfDbProduct(state?.data)
    ),
    margin: getProfitMargin(
      state?.data?.price?.unit_sell_price,
      state?.data?.price?.unit_purchase_price
    ),
    unitsOnHand:
      (state?.data?.trackQuantity && state?.data?.price?.quantity != null) ||
      state?.data?.trackQuantity === undefined ||
      state?.data?.trackQuantity === null
        ? state.data.price.quantity
        : EMPTY_STRING,
    originalPrice: state?.data?.price?.unit_sell_price || 0,
    originalCondition: state?.data?.price?.type || EMPTY_STRING,
    upc: state?.data?.upc || EMPTY_STRING,
    trackQuantity:
      state?.data?.trackQuantity === undefined ||
      state?.data?.trackQuantity === null
        ? true
        : state?.data?.trackQuantity,
    isInstoreStockPrice: false,
    ...getAddInventoryPartialInitialValues(
      {
        ...state?.data,
        ...state?.data?.price,
      },
      INITIAL_VALUE_TYPES.EDIT_INVENTORY
    ),
  };

  //-------Toggle Print Label Modal
  const togglePrintLabelModal = () => {
    setPrintLabelModal(!printLabelModal);
  };
  const handleCancelButton = () => {
    navigate(createCompanyDynamicUrl(routesPathConstants.INVENTORY), {
      state: {
        gridState: state?.gridState,
        scrollRef: state?.scrollRef,
      },
    });
  };

  //------- toggle shopify mapping modal
  const toggleShopifyMappingModal = () => {
    if (isShopifyPresetModal) {
      setInitialMapping(false);
    }
    setIsShopifyPresetModal((prev) => !prev);
  };
  const updateProductShopifySetting = (data) => {
    setProductDataObject({
      ...productDataObject,
      shopifySettingId: data.id,
    });
  };

  //-------handle save mapping
  const handleSaveMappning = (updatedFields) => {
    let dataToUpdate = {
      ...productShopifySettings?.marginObject,
      companyId: currentStore?.companyId,
      shopifyMapping: getMappedShopifyFields(updatedFields),
    };
    createProductMappingObject(
      currentStore?.companyId,
      dataToUpdate,
      toggleShopifyMappingModal,
      updateProductShopifySetting
    );
  };

  const handleShrinkModalSubmit = (isAddQuantityInShrink) => {
    setShow(false);
    updateInventory(
      currentStore?.id,
      handleAddInventorySubmitBeautify(updatedInventory),
      true,
      state?.gridState,
      navigate,
      state?.scrollRef,
      isAddQuantityInShrink
    );
    if (isAddQuantityInShrink) {
      const shrinkInventoryObject = {
        ...state.data,
        shrinkQuantity: shrinkValue,
      };
      quantityShrink([shrinkInventoryObject]);
    }
  };

  const updateGridState = (gridState) => {
    getPaginatedInventoryHistory(currentStore?.id, gridState);
    setGridState(gridState);
  };

  //------- handle item history button click
  const handleItemHistory = () => {
    toggleItemHistoryModal();
  };

  //------ handle value change of sell price, cost price and price toogle (online or offline price)
  const handlePriceChange = (
    values,
    costPriceValue,
    sellPriceValue,
    setFieldValue,
    isInstoreStockPrice
  ) => {
    let cost = 0;
    let price = 0;
    let isEditingOnlinePricing = false;

    if (isInstoreStockPrice === undefined) {
      isEditingOnlinePricing = values?.isInstoreStockPrice;
    } else {
      setFieldValue("isInstoreStockPrice", isInstoreStockPrice);
      isEditingOnlinePricing = isInstoreStockPrice;
    }
    if (costPriceValue === undefined) {
      cost = getUnitPurchasePriceOfDbProduct(
        values,
        PRODUCT_JSON_TYPE.EDIT_INVENTORY,
        isEditingOnlinePricing
      );
    } else {
      cost = Number(costPriceValue);
    }
    if (sellPriceValue === undefined) {
      price = Number(
        values?.[
          isEditingOnlinePricing ? "onlineUnitSellPrice" : "unitsellprice"
        ]
      );
    } else {
      price = Number(sellPriceValue);
    }

    const { profit, margin } = calculateProfitAndMargin(cost, price);
    setFieldValue(isEditingOnlinePricing ? "onlineProfit" : "profit", profit);
    setFieldValue(isEditingOnlinePricing ? "onlineMargin" : "margin", margin);
  };

  const handleSubmit = (data) => {
    if (
      data?.serialNumber &&
      Number(data.unitsOnHand) + Number(data.onlineQuantity) > 1
    ) {
      customToast(toastMessages.SYSTEM_QUANTITY_MUST_BE_1, toastType.ERROR);
      return;
    } else if (
      isSystemProduct(getProductSubCategory(productDataObject?.genre)) &&
      !isSerialNumberUnique(
        data.serialNumber,
        inventoryProducts?.filter(
          (product) => product.id !== state?.data?.id
        ) || []
      )
    ) {
      customToast(
        toastMessages.PRODUCT_SERIAL_NUMBER_SHOULD_BE_UNIQUE,
        toastType.ERROR
      );
      return;
    }
    // if category is deleted after product creation then category_name will be null so we need to check that in validation before submitting the form
    else if (!data.category_name) {
      customToast(toastMessages.CATEGORY_IS_REQUIRED, toastType.ERROR);
      return;
    }
    const updateInventoryObject = {
      ...getAddInventoryRootPayloadPartialObject({
        ...productDataObject,
        ...data,
        shopifySettingId:
          productShopifySettings?.marginObject?.id ||
          productDataObject.shopifySettingId,
        productType: getTypeOrCategoryObject(customTypes, data.productType)
          ?.productType,
      }),
      id: state?.data?.id,
      product_name: data?.productName,
      margin: data.margin,
      imgUrl: productDataObject?.imgUrl || EMPTY_STRING,
      imgUrlExtras: productDataObject.imgUrlExtras || [],
      fallbackImgUrl: productDataObject?.fallbackImgUrl || EMPTY_STRING,
      tags: selectedTags,
      category_name: getTypeOrCategoryObject(
        customCategories,
        data.category_name
      )?.name,
      subcategory:
        !handleIsCustomItem({ tags: selectedTags }) &&
        productDataObject.productType === PRODUCT_TYPES_ENUMS.TRADING_CARD
          ? productDataObject.subcategory
          : getTypeOrCategoryObject(customSubCategories, data.subcategory)
              ?.name ?? EMPTY_STRING,
      price: {
        ...getAddInventoryPricePayloadObject({
          ...productDataObject,
          ...data,
          isSeparateQuantity: data.isOnlineQuantity,
        }),
        type: isCustomItem
          ? data?.condition
          : productCondition?.value ?? EMPTY_STRING,
        quantity: data?.trackQuantity ? data.unitsOnHand : 0,
        unit_purchase_price: data.costPerItem,
        unit_sell_price: data.unitsellprice,
        originalPrice: data.originalPrice,
        originalCondition: data?.originalCondition,
        marketPrice: handleBeautifyMarketPrice(productDataObject),
        profit: data.profit,
      },
      trackQuantity: data?.trackQuantity,
    };
    // consolidation test (if isConsolidationModal === true i.e user pressed yes so submit the form)
    const isConsolidation = inventoryProducts
      .filter(
        (inv) =>
          inv.id !== updateInventoryObject.id &&
          inv.store?.id === currentStore?.id
      )
      .find((inv) => {
        return isProductMetaDataSame(inv, updateInventoryObject);
      });
    if (
      isConsolidation &&
      !isConsolidationModal &&
      data.serialNumber !== EMPTY_STRING
    ) {
      customToast(
        toastMessages.PRODUCT_SERIAL_NUMBER_SHOULD_BE_UNIQUE,
        toastType.ERROR
      );
      return;
    } else if (isConsolidation && !isConsolidationModal) {
      setIsConsolidationModal(true);
      return;
    }
    if (data.unitsOnHand < state?.data?.price?.quantity) {
      setShrinkValue(state?.data?.price?.quantity - data.unitsOnHand);
      handleShow();
      setUpdatedInventory(updateInventoryObject);
    } else {
      updateInventory(
        currentStore?.id,
        handleAddInventorySubmitBeautify(updateInventoryObject),
        true,
        state?.gridState,
        navigate,
        state?.scrollRef
      );
    }
  };
  const handlePrintButtonClick = () => {
    togglePrintLabelModal();
  };

  //------- Hide/Show Item History Modal
  const toggleItemHistoryModal = () => {
    setIsItemHistoryModal(!isItemHistoryModal);
  };

  const getProductDefaultShopifySettingId = (formValues) => {
    const currentProductType =
      getTypeOrCategoryObject(customTypes, formValues?.productType)
        ?.productType || state?.data?.productType;
    const currentCategory =
      getTypeOrCategoryObject(customCategories, formValues?.category_name)
        ?.name || state?.data?.category_name;
    const currentSubcategory =
      getTypeOrCategoryObject(customSubCategories, formValues?.subcategory)
        ?.name || state?.data?.subcategory;

    return getDefaultShopifySettings(
      handleBeautifyMarketPrice(productDataObject) || formValues?.unitsellprice,
      shopify?.shopifySettings,
      currentProductType,
      {
        ...productDataObject,
        genre: currentSubcategory,
        consoleName: currentCategory,
        condition: formValues?.condition,
        tags: selectedTags,
      },
      false
    )?.marginObject?.id;
  };

  //------ handleEditShopifyPreset
  const handleEditShopifyPreset = () => {
    setInitialMapping(false);
    toggleShopifyMappingModal();
    getShopifyMappingsById(
      currentStore?.companyId,
      state?.data?.shopifySettingId ||
        productShopifySettings?.marginObject?.id ||
        productDataObject?.shopifySettingId
    );
  };

  //------- handleIsLinkToShopifyCheck
  const handleIsLinkToShopifyCheck = (name, value, values, setFieldValue) => {
    setFieldValue(name, value);
    if (value) {
      if (
        !productDataObject?.shopifySettingId &&
        !state?.data?.shopifySettingId
      ) {
        /*
         * If shopifySettingId is not exists in product e.g Product added before shopify implementation (Old products)
         * then get default shopify setting according to preset priority.
         */
        const shopifySettingId = getProductDefaultShopifySettingId(
          formRef?.current?.values
        );
        if (shopifySettingId) {
          setProductDataObject((prev) => ({
            ...prev,
            shopifySettingId,
          }));
        }
      }
    }
    if (!value) {
      setFieldValue("isOnlineQuantity", value);
      setFieldValue("isInstoreStockPrice", value);
      //setFieldValue("isOnlineUnitSellPrice", value);
      handlePriceChange(values, undefined, undefined, setFieldValue, value);
      handleSeparateOnlineQuantityChange(
        "isOnlineQuantity",
        value,
        values,
        setFieldValue
      );
    }
  };

  //-------- handleSeparateOnlineQuantityChange
  const handleSeparateOnlineQuantityChange = (
    name,
    value,
    values,
    setFieldValue
  ) => {
    const onlineQuantity = values?.onlineQuantity || 0;
    const inStoreQuantity = values?.unitsOnHand || 0;
    const isOnlineQuantity = value;

    const totalQuantity = Number(onlineQuantity) + Number(inStoreQuantity);
    setFieldValue(name, isOnlineQuantity);
    if (!isOnlineQuantity) {
      setFieldValue("unitsOnHand", totalQuantity);
      const newCogs = handleAverageOutUnitPurcasePrice(
        inStoreQuantity,
        onlineQuantity,
        values?.costPerItem,
        values?.onlineCostPerItem
      );
      setFieldValue("costPerItem", newCogs);
      setFieldValue("onlineCostPerItem", newCogs);
    } else {
      setFieldValue("unitsOnHand", inStoreQuantity);
      setFieldValue("onlineQuantity", 0);
      setFieldValue("costPerItem", state?.data?.price?.unit_purchase_price);
      setFieldValue(
        "onlineCostPerItem",
        state?.data?.price?.onlineUnitPurchasePrice
      );
    }
  };
  const toggleTransferInventoryModal = () => {
    setIsTransferInventoryModal((prev) => !prev);
  };

  //------- get item history paginated
  useEffect(() => {
    if (currentStore && timeFrame.start && timeFrame.end) {
      updateGridState({
        ...gridState,
        pageSize: inventoryConstants.ITEM_HISTORY_LIST_LENGTH,
        searchQuery: getShortestSku(state?.data?.sku),
        filters: prepareFilterForInventoryHistoryPaginationCall(
          EMPTY_STRING,
          EMPTY_STRING,
          transactionType,
          timeFrame.start,
          timeFrame.end,
          EMPTY_STRING
        ),
      });
    }
  }, [timeFrame, transactionType, currentStore]);

  useEffect(() => {
    const productMetaData = {
      ...state?.data,
      id: state?.data?.product_id,
      category_name: state?.data.category_name,
      genre: isSystemProduct(state?.data.subcategory)
        ? state?.data.subcategory
        : state?.data.category_name,
      imgUrl: state?.data.imgUrl,
      productType: state?.data.productType,
      product_id: state?.data.product_id,
      product_name: state?.data.product_name,
      sourceApi: state?.data.apiSource,
    };
    if (state?.data.apiSource === inventoryConstants.PRICECHARTING_API) {
      getPricechartingProductById(
        productMetaData,
        state?.data?.product_id,
        true
      );
    } else if (state?.data.apiSource === inventoryConstants.TCG_PLAYER_API) {
      getTcgPlayerProductById(productMetaData, productMetaData.id);
    } else if (state?.data.apiSource === inventoryConstants.CUSTOM_ITEM) {
      getInventoryByCustomItemCheck(currentStore?.id);
    } else if (state?.data.apiSource === inventoryConstants.CSV_IMPORT_FILE) {
      setPokemonProductInReducer(productMetaData, state?.data);
    }
    return () => {
      emptyPriceChartingProductObject();
    };
  }, []);

  useEffect(() => {
    if (
      state?.data?.shopifySettingId &&
      isShopifyConnected(currentStore) &&
      state?.data?.isLinkToShopify
    ) {
      getShopifyMappingsById(
        currentStore?.companyId,
        state?.data?.shopifySettingId
      );
    }
  }, [
    currentStore?.companyId,
    getShopifyMappingsById,
    state?.data?.shopifySettingId,
    state?.data?.isLinkToShopify,
  ]);

  //-------update product condition and type
  useEffect(() => {
    const handleProductDefaultObject = async () => {
      if (priceChartingProductInfo.productObject) {
        await setDefaultProductDataObject(
          currentStore,
          priceChartingProductInfo,
          getInventoryByPricechartingId,
          setProductType,
          setProductUrl,
          productDataObject,
          setProductDataObject,
          productTags,
          setProductTagsList,
          () => {},
          () => {},
          setConditionList,
          setProductCondition,
          state?.data?.imgUrl
        );

        if (isFirstRenderRef.current) {
          isFirstRenderRef.current = false;
          const initialCondition = {
            label: state?.data?.price?.type,
            value: state?.data?.price?.type,
          };
          handleConditionChange(
            initialCondition,
            () => {},
            priceChartingProductInfo,
            productTags,
            setProductTagsList,
            setProductDataObject,
            productDataObject,
            () => {}
          );
          setProductCondition(initialCondition);
          setSelectedTags(state?.data?.tags);
        }
      }
    };
    handleProductDefaultObject();
  }, [priceChartingProductInfo.productObject]);

  useEffect(() => {
    if (productShopifySettings?.marginObject?.id) {
      setInitialMapping(getDefaultFields(productShopifySettings?.marginObject));
    }
  }, [productShopifySettings]);

  useEffect(() => {
    return () => {
      emptyShopifyProductSettings();
    };
  }, []);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={editInventoryValidationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ values, setFieldValue }) => {
          return (
            <>
              <Topbar
                exportButton={true}
                title="Inventory Detail - Edit"
                handleClick={handlePrintButtonClick}
                label={buttonNameConstants.PRINT_PRODUCT_LABEL}
                buttonType={buttonTypeConstants.LIGHT_PURPLE}
                backNavigation={{
                  isVisible: true,
                  route: routesPathConstants.INVENTORY,
                  gridState: state?.gridState,
                  scrollRef: state?.scrollRef,
                }}
                isGhostButton={{
                  isVisible: true,
                  handleButtonClick: handleItemHistory,
                  buttonLabel: buttonNameConstants.ITEM_HISTORY,
                }}
                isEditShopifyPresetsButton={
                  isShopifyStoreConnected &&
                  formRef?.current?.values?.isLinkToShopify
                    ? {
                        isVisible: true,
                        handleButtonClick: handleEditShopifyPreset,
                        buttonLabel: buttonNameConstants.EDIT_SHOPIFY_PRESET,
                        isDisabled: isSpinnerEnabled(
                          spinnerArray,
                          shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID
                        )
                          ? true
                          : false,
                      }
                    : ""
                }
                isTransferButton={{
                  isVisible: isTransferInventoryEnabled(
                    currentStoreCompany,
                    stores
                  ),
                  handleButtonClick: toggleTransferInventoryModal,
                  buttonLabel: buttonNameConstants.TRANSFER,
                }}
              ></Topbar>
              <Row className="m-0 w-100  container-scrollbar user-information-wrapper edit-inventory-wrapper  pb-3">
                <Col className="p-0">
                  <Form className="main-row">
                    <Row className="m-0 mb-3  ">
                      {/* Product info section */}
                      <EditInventoryLeftColumn
                        state={state}
                        values={values}
                        productType={productType}
                        selectedTags={selectedTags}
                        isCustomItem={isCustomItem}
                        setProductUrl={setProductUrl}
                        setShowIframe={setShowIframe}
                        hiddenFileInput={hiddenFileInput}
                        setSelectedTags={setSelectedTags}
                        productTagsList={productTagsList}
                        productCondition={productCondition}
                        productDataObject={productDataObject}
                        setProductDataObject={setProductDataObject}
                      />
                      {/* Edit Product Details Section */}
                      <EditInventoryRightColumn
                        state={state}
                        values={values}
                        isCustomItem={isCustomItem}
                        selectedTags={selectedTags}
                        setFieldValue={setFieldValue}
                        conditionList={conditionList}
                        setSelectedTags={setSelectedTags}
                        setConditionList={setConditionList}
                        productCondition={productCondition}
                        handlePriceChange={handlePriceChange}
                        productDataObject={productDataObject}
                        setProductTagsList={setProductTagsList}
                        handleCancelButton={handleCancelButton}
                        setProductDataObject={setProductDataObject}
                        setProductCondition={setProductCondition}
                        isShopifyStoreConnected={isShopifyStoreConnected}
                        handleIsLinkToShopifyCheck={handleIsLinkToShopifyCheck}
                        handleSeparateOnlineQuantityChange={
                          handleSeparateOnlineQuantityChange
                        }
                      />
                    </Row>
                  </Form>{" "}
                </Col>
              </Row>
            </>
          );
        }}
      </Formik>
      {isConsolidationModal && (
        <ConfirmationModal
          isConfirmationModal={isConsolidationModal}
          handleNoButtonClick={() => {
            setIsConsolidationModal(false);
          }}
          handleYesButtonClick={() => {
            if (formRef.current) {
              formRef.current.handleSubmit();
            }
          }}
          message="An item with these details already exists. Saving/Adding will transfer the quantity of this version into an existing version. Proceed?"
        />
      )}
      <Modal
        size="md"
        animation={true}
        centered
        backdrop="static"
        show={show}
        className={"nested-modal-z-index"}
        backdropClassName={"nested-modal-z-index"}
      >
        <Modal.Body>
          {" "}
          <Row className="m-0 p-0">
            <Col
              md={3}
              className="img-Div-stolen d-flex p-0 box-shadow-default"
            >
              <ProductImageCard src={getProductImage(state?.data)} />
            </Col>
            <Col md={9} className="m-0 pe-0">
              <Row className="m-0 p-0 h-100">
                <Col md={12} className="p-0 mt-2 stolen-card-text ">
                  Was {state?.data?.product_name} lost or stolen?
                </Col>
                <Col md={12} className="mt-auto p-0 d-flex gap-2 ">
                  <Button
                    type="button"
                    label={buttonNameConstants.NO}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    className="w-100"
                    handleClick={() => {
                      // handleCancelButton();
                      handleShrinkModalSubmit(false);
                    }}
                  ></Button>
                  <Button
                    type="button"
                    className="w-100"
                    handleClick={() => {
                      // setShrinkValue(buttonNameConstants.YES);
                      handleShrinkModalSubmit(true);
                    }}
                    label={buttonNameConstants.YES}
                  ></Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        size="xl"
        animation={true}
        centered
        backdrop="static"
        show={showIframe}
        onHide={handleCloseIfram}
        // className="iframe-edit-inventory"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <iframe
            title="Product Iframe"
            src={productUrl}
            className="iframe-website-edit-inventory  w-100"
          />
        </Modal.Body>
      </Modal>
      <PrintLabelModal
        printLabelModal={printLabelModal}
        togglePrintLabelModal={togglePrintLabelModal}
        // selectedRows={selectedRows}
        singlePrintArray={[state?.data]}
      />
      {isItemHistoryModal ? (
        <ItemHistoryModal
          item={state?.data}
          timeFrame={timeFrame}
          gridState={gridState}
          setGridState={setGridState}
          setTimeFrame={setTimeFrame}
          inventoryHistory={inventoryHistory}
          updateGridState={updateGridState}
          setTransactionType={setTransactionType}
          isItemHistoryModal={isItemHistoryModal}
          toggleItemHistoryModal={toggleItemHistoryModal}
        />
      ) : (
        ""
      )}{" "}
      {isTransferInventoryModal && (
        <TransferInventoryModal
          stateData={{
            navigate: navigate,
            data: state?.data,
          }}
          selectedRows={[]}
          isEditInventory={true}
          singlePrintArray={[state?.data]}
          isTransferInventoryModal={isTransferInventoryModal}
          toggleTransferInventoryModal={toggleTransferInventoryModal}
        />
      )}
      {isShopifyStoreConnected && initialMapping && (
        <ShopifyPresetsMappingModal
          isShowSkeleton={isSpinnerEnabled(
            spinnerArray,
            shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID
          )}
          initialMappings={initialMapping}
          handleSaveClick={handleSaveMappning}
          isShopifyMappingModal={isShopifyPresetModal}
          toggleShopifyMappingModal={toggleShopifyMappingModal}
        />
      )}
    </>
  );
};

//-------EditInventory component ends here

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  shopify: state.shopify,
  inventory: state.inventory,
  stores: state.store.stores,
  tradeDiscount: state.tradeDiscount,
  company: state.authentication.company,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  productTags: state.inventory.productTags,
  customTypes: state.itemOrganization.customTypes,
  inventoryProducts: state.inventory.inventoryProducts,
  currentStoreCompany: state.company.currentStoreCompany,
  customCategories: state.itemOrganization.customCategories,
  customSubCategories: state.itemOrganization.customSubCategories,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  quantityShrink: (data) => dispatch(inventoryActions.quantityShrink(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  emptyPriceChartingProductObject: () =>
    dispatch(inventoryActions.emptyPriceChartingProductObject()),
  getInventoryByPricechartingId: (storeId, data) =>
    dispatch(inventoryActions.getInventoryByPricechartingId(storeId, data)),
  getInventoryByCustomItemCheck: (storeId) =>
    dispatch(inventoryActions.getInventoryByCustomItemCheck(storeId)),
  getPaginatedInventoryHistory: (storeId, gridState) =>
    dispatch(inventoryActions.getPaginatedInventoryHistory(storeId, gridState)),
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
  getShopifyMappingsById: (companyId, id) =>
    dispatch(shopifyActions.getShopifyMappingsById(companyId, id)),
  getPricechartingProductById: (...args) =>
    dispatch(inventoryActions.getPricechartingProductById(...args)),
  setPokemonProductInReducer: (productMetaData, value) =>
    dispatch(
      inventoryActions.setPokemonProductInReducer(productMetaData, value)
    ),
  getTcgPlayerProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getTcgPlayerProductById(productMetaData, productId)
    ),
  updateInventory: (
    storeId,
    data,
    isLabelNotification,
    gridState,
    isPageRedirect,
    scrollRef,
    isAddShrinkTracking
  ) =>
    dispatch(
      inventoryActions.updateInventory(
        storeId,
        data,
        isLabelNotification,
        gridState,
        isPageRedirect,
        scrollRef,
        isAddShrinkTracking
      )
    ),
  setProductShopifySettings: (data) =>
    dispatch(inventoryActions.setProductShopifySettings(data)),
  createProductMappingObject: (companyId, data, toggleShopifyMappingModal) =>
    dispatch(
      shopifyActions.createProductMappingObject(
        companyId,
        data,
        toggleShopifyMappingModal
      )
    ),
  emptyShopifyProductSettings: () =>
    dispatch(shopifyActions.emptyShopifyProductSettings()),
});

//-------Export EditInventory Component
export default connect(mapStateToProps, mapDispatchToProps)(EditInventory);
